import { CommonModule } from "@angular/common";
import { booleanAttribute, Component, input, output } from "@angular/core";
import { Icon } from "../icon/icon.component";
import { BaseConfig } from "../common/config/config.adapter";

@Component({
    selector: "app-name-tag",
    template: `
        <div
            class="bg-gray-100 flex items-center gap-1 px-2 py-1 rounded-lg w-max"
        >
            <p class="text-xs text-gray-500">
                <ng-content />
            </p>
            @if (!invisibleClose()) {
                <app-icon
                    (click)="close.emit()"
                    name="solar:close-circle-bold-duotone"
                    class="text-gray-400 cursor-pointer"
                    size="sm"
                />
            }
        </div>
    `,
    standalone: true,
    imports: [Icon, CommonModule],
})
export class NameTag extends BaseConfig {
    close = output();
    invisibleClose = input<boolean, string>(false, {
        transform: booleanAttribute,
    });
}
